var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "groupbuy-list"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("總公司團購列表")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("總公司團購列表")])]), _c('div', {
    staticClass: "\n          col-6\n          d-flex\n          justify-content-end\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.MAIN_STORE_GROUPBUYING_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreateByScan
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("門市庫存品開團")]) : _vm._e(), _vm.checkPermission([_vm.consts.MAIN_GROUPBUYING_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("總公司選品開團")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row align-items-center mb-3"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "align-items-center mb-2 mb-xl-0"
  }, [_c('b-form-group', {
    staticClass: "flex-shrink-0 ml-1 ml-xl-2 mb-0",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var ariaDescribedby = _ref.ariaDescribedby;
        return [_c('b-form-checkbox-group', {
          attrs: {
            "id": "checkbox-group-1",
            "options": _vm.statusOptions,
            "aria-describedby": ariaDescribedby
          },
          on: {
            "change": function change($event) {
              return _vm.handleCheckedTypes();
            }
          },
          model: {
            value: _vm.selectedTypes,
            callback: function callback($$v) {
              _vm.selectedTypes = $$v;
            },
            expression: "selectedTypes"
          }
        })];
      }
    }])
  })], 1)])]), _c('div', {
    staticClass: "d-flex flex-wrap mb-3 justify-content-end"
  }, [_c('div', {
    staticClass: "row-searchbar d-flex mb-2 mb-md-0 mr-md-2"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "120px",
      "height": "45px"
    },
    attrs: {
      "options": _vm.SEARCH_OPTIONS
    },
    model: {
      value: _vm.keyword_type,
      callback: function callback($$v) {
        _vm.keyword_type = $$v;
      },
      expression: "keyword_type"
    }
  }), _c('div', {
    staticClass: "w-100"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.PLACEHOLDER_MAP[_vm.keyword_type]
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getGroupbuyList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  })], 1)], 1), _c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "disabledEndAtDates": _vm.disabledEndAtDates
    },
    on: {
      "update:disabledEndAtDates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "update:disabled-end-at-dates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      }
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _c('b-button', {
    on: {
      "click": _vm.getGroupbuyList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1), _c('b-tabs', {
    on: {
      "input": _vm.handleChangeTab
    },
    model: {
      value: _vm.currentTabIndex,
      callback: function callback($$v) {
        _vm.currentTabIndex = $$v;
      },
      expression: "currentTabIndex"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('b-tab', {
      key: tab.status,
      attrs: {
        "title": tab.title
      }
    }, [_c('b-card-text', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('b-table', {
      attrs: {
        "striped": "",
        "hover": "",
        "responsive": "",
        "items": _vm.groupbuys,
        "fields": _vm.fields,
        "busy": _vm.isFetchGroupbuyList
      },
      scopedSlots: _vm._u([{
        key: "table-busy",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-center my-2"
          }, [_c('b-spinner', {
            staticClass: "align-middle"
          })], 1)];
        },
        proxy: true
      }, {
        key: "cell(groupbuying_number)",
        fn: function fn(data) {
          return [_c('router-link', {
            attrs: {
              "to": {
                name: 'GroupbuyingsDetail',
                params: {
                  groupbuyID: data.item.id
                }
              }
            }
          }, [_vm._v(_vm._s(data.item.groupbuying_number) + " ")])];
        }
      }, {
        key: "cell(title)",
        fn: function fn(data) {
          return [_c('a', {
            attrs: {
              "href": "javascript:;"
            },
            on: {
              "click": function click($event) {
                $event.preventDefault();
                return _vm.handleViewDetail(data.item);
              }
            }
          }, [_c('div', [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].title) + " ")]), _c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(data.item.products[0] && data.item.products[0].sale_page_code) + " ")])])];
        }
      }, {
        key: "cell(picture)",
        fn: function fn(data) {
          return [data.item.products[0] && data.item.products[0].image_list[0] && data.item.products[0].image_list[0].pic_url ? _c('b-img-lazy', {
            staticClass: "thumb-image",
            attrs: {
              "src": data.item.products[0] && data.item.products[0].image_list[0].pic_url,
              "alt": "商品圖片",
              "width": "50",
              "height": "50"
            }
          }) : _vm._e()];
        }
      }, {
        key: "cell(date)",
        fn: function fn(data) {
          return [_c('div', {
            staticClass: "mb-1"
          }, [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.start_at), "yyyy-MM-dd HH:mm")) + " ")]), _c('div', [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.end_at), "yyyy-MM-dd HH:mm")) + " ")])];
        }
      }], null, true)
    })], 1)])])], 1);
  }), 1), _c('div', {
    staticClass: "\n        d-flex\n        justify-content-center\n        align-items-center\n        flex-column flex-md-row\n      ",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    staticClass: "separated mb-2 mb-md-0",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.query.per_page,
      "aria-controls": "groupbuyList"
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.query.page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "page", $$v);
      },
      expression: "query.page"
    }
  }), _c('div', {
    staticClass: "ml-2"
  }, [_vm._v(" 每頁顯示數量"), _c('b-form-select', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "change": _vm.handleChangePage
    },
    model: {
      value: _vm.query.per_page,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "per_page", $$v);
      },
      expression: "query.per_page"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }